(() => {
  if (!customElements.get('nv-formula-explorer')) {
    customElements.define('nv-formula-explorer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        const tabs = Array.from(this.querySelectorAll('[data-nv-formula-tab]'));
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        const images = Array.from(this.querySelectorAll('[data-nv-capsule-image]'));
        const select = tab => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');});
          images.forEach(image => {image.hidden = image.dataset.nvCapsuleImage !== tab.dataset.nvFormulaTab;});
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab), options);
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
            if (event.key === 'ArrowLeft') target = tabs[(index + tabs.length - 1) % tabs.length];
            if (event.key === 'Home') target = tabs[0];
            if (event.key === 'End') target = tabs[tabs.length - 1];
            if (!target) return;
            event.preventDefault(); select(target); target.focus();
          }, options);
        });
        panels.forEach(panel => {
          const buttons = Array.from(panel.querySelectorAll('[data-nv-ingredient]'));
          buttons.forEach(button => button.addEventListener('click', () => {
            buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            panel.querySelectorAll('[data-nv-ingredient-detail]').forEach(detail => {detail.hidden = detail.dataset.nvIngredientDetail !== button.dataset.nvIngredient;});
          }, options));
        });
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }

})();
